import { css } from "styled-components";
export default css`
    .ant-message-notice-content {
        border-radius: 8px;
        background-color: #373f42;
        color: white;
        padding: unset;
    }
    .ant-message-custom-content {
        border-radius: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 16px;
        font-size: 12px;

        &> span:nth-child(2) {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        svg {
            width: 12px;
            height: 12px;
        }

        .message {
            margin-right: 8px;
        }

        .anticon-close {
            color: #fff;
        }
    }
    .info, .warning {
        & .ant-message-custom-content {
            background: #fbc74b3c;
            border: 2px solid #fbc74b;
        }
    }
    .success {
        & .ant-message-custom-content {
            background: #87d06836;
            border: 2px solid #87d068;
        }
    }
    .error {
        & .ant-message-custom-content {
            background: hsl(1deg 76% 43% / 31%);
            border: 2px solid #C11D1A;
        }
    }
`;